/* unplugin-vue-components disabled */import script from "./TransactionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&setup=true&lang=js"

import "./TransactionDetail.vue?vue&type=style&index=0&id=10f1fe60&lang=scss"

const __exports__ = script;

export default __exports__